<template>
  <div :id="'chart' + this.uniqueId"></div>
</template>

<script>
const am4core = require("@amcharts/amcharts4/core");
const am4charts = require("@amcharts/amcharts4/charts");
import am4themes_material from "@amcharts/amcharts4/themes/material";

export default {
  components: {},
  props: {
    data: { type: Array },
    headingColumn: { type: String, default: "" },
    dataColumn: { type: String, default: "" },
    showPercentage: { type: Boolean, default: false },
    showLegend: { type: Boolean, default: true },
    showTooltips: { type: Boolean, default: true },
    wrap: { type: Boolean, default: false },
    wrapWidth: { type: Number, default: 130 },
  },
  data: function () {
    return {
      total: 0,
      chart: null,
      uniqueId: Math.random().toFixed(2),
    };
  },
  methods: {
    GenerateChart(ID) {
      am4core.useTheme(am4themes_material);
      this.chart = null;

      this.chart = am4core.create(ID, am4charts.PieChart);

      this.chart.autoMargins = true;

      this.chart.data = this.data;

      this.chart.innerRadius = am4core.percent(40);

      let pieSeries = this.chart.series.push(new am4charts.PieSeries());

      if (this.wrap) {
        pieSeries.labels.template.maxWidth = this.wrapWidth;
        pieSeries.labels.template.wrap = true;
      }

      pieSeries.dataFields.value = this.dataColumn;
      pieSeries.dataFields.category = this.headingColumn;

      pieSeries.slices.template.stroke = am4core.color("#FFFFFF");
      pieSeries.slices.template.strokeWidth = 0;
      pieSeries.slices.template.strokeOpacity = 1;

      pieSeries.labels.template.text = this.showPercentage && this.data.percentage ? `{${this.headingColumn}}: {${this.dataColumn}} / {percentage}` : `{${this.headingColumn}}: {${this.dataColumn}}`;

      pieSeries.slices.template.propertyFields.fill = "color";
      pieSeries.slices.template.stoke = am4core.color("white");
      pieSeries.slices.template.strokeWidth = 1;
      pieSeries.slices.template.strokeOpacity = 1;

      if (!this.showTooltips) {
        pieSeries.labels.template.disabled = true;
        pieSeries.ticks.template.disabled = true;
      }

      this.chart.hiddenState.properties.radius = am4core.percent(0);

      if (this.showLegend) {
        this.chart.legend = new am4charts.Legend();
        this.chart.legend.valueLabels.template.text = this.showPercentage && this.data.percentage ? `{${this.headingColumn}}: {${this.dataColumn}} / {percentage}` : `{${this.dataColumn}}`;
        this.chart.legend.valueLabels.template.align = "left";
        this.chart.legend.valueLabels.template.textAlign = "end";
        this.chart.legend.maxHeight = 150;
        this.chart.legend.maxWidth = undefined;
      }
    },
    UpdateChartData() {
      this.chart.data = this.data;
    },
  },
  mounted() {
    this.GenerateChart("chart" + this.uniqueId);
  },
  beforeDestroy() {
    this.chart.dispose();
  },
  watch: {
    data: function () {
      this.UpdateChartData();
    },
  },
};
</script>

<style scoped></style>
